/* Stock presentation only. Shopify and the existing variant app remain authoritative. */
(() => {
  if(window.MouniStockGuard)return;
  let cart=null, queued=0;
  const roots=()=>document.querySelectorAll('[data-mouni-product]');
  const used=id=>(cart?.items||[]).reduce((sum,item)=>sum+(String(item.variant_id??item.id)===String(id)?Number(item.quantity):0),0);
  const variantFor=root=>{
    const source=root.querySelector('[data-mouni-stock-variants]');
    if(!source)return null;
    const variants=JSON.parse(source.textContent);
    const id=root.querySelector('form[action*="/cart/add"] [name=id]')?.value;
    return variants.find(v=>String(v.id)===String(id));
  };
  const capacity=v=>window.MouniCommerce?.remaining(v,cart)??(!v?.available?0:!v.inventory_management?Infinity:Math.max(0,Number(v.inventory_quantity)-used(v.id)));
  const buttonState=(button,blocked)=>{
    if(blocked){if(!button.dataset.mouniStockDisabled)button.dataset.mouniStockWasDisabled=String(button.disabled);button.dataset.mouniStockDisabled='true';button.disabled=true;button.setAttribute('aria-disabled','true');}
    else if(button.dataset.mouniStockDisabled){button.disabled=button.dataset.mouniStockWasDisabled==='true';button.removeAttribute('aria-disabled');delete button.dataset.mouniStockDisabled;delete button.dataset.mouniStockWasDisabled;}
  };
  const sync=()=>{
    roots().forEach(root=>{
      const v=variantFor(root);if(!v)return;const left=capacity(v);
      const minimum=window.MouniCommerce?.minimum?.(v.id)||1;
      root.querySelectorAll('quantity-input').forEach(group=>{
        const input=group.querySelector('input[name=quantity]');if(!input)return;
        if(Number.isFinite(left))input.max=String(Math.max(1,left));else input.removeAttribute('max');
        input.min=String(minimum);
        if(Number(input.value)>left && left>=minimum){input.value=String(left);input.dispatchEvent(new Event('change',{bubbles:true}));}
        group.querySelectorAll('button.plus,button[name=plus]').forEach(b=>buttonState(b,left<=Number(input.value||1)));
        group.querySelectorAll('button.minus,button[name=minus]').forEach(b=>buttonState(b,Number(input.value||1)<=minimum));
      });
      root.querySelectorAll('#product-add-to-cart,.product-form__submit,.shopify-payment-button__button').forEach(b=>buttonState(b,left<minimum));
      root.dataset.mouniStockRemaining=Number.isFinite(left)?String(left):'unlimited';
    });
  };
  const schedule=()=>{cancelAnimationFrame(queued);queued=requestAnimationFrame(sync);};
  const adopt=event=>{const next=event.detail?.cart||event.detail;if(next?.items){cart=next;schedule();}};
  ['mouni:inventory-cart','mouni:cart-updated','mouni:v37-cart-painted','mouni:cart-html-refreshed'].forEach(name=>document.addEventListener(name,adopt));
  const syncQuantity=event=>{
    const input=event.target,root=input.closest('.product-details[data-mouni-product]');
    if(root && input.matches('quantity-input input[name=quantity]')){
      if(event.type==='input' && input.value && input.validity.valid){
        input.dispatchEvent(new Event('change',{bubbles:true}));
        return;
      }
      root.querySelectorAll('quantity-input input[name=quantity]').forEach(other=>{if(other!==input)other.value=input.value;});
      root.querySelectorAll('form[data-mouni-enabled="true"]').forEach(form=>window.MouniCommerce?.syncForm(form));
    }
    if(root)schedule();
  };
  document.addEventListener('change',syncQuantity);
  document.addEventListener('input',syncQuantity);
  document.addEventListener('click',event=>{if(event.target.closest('[data-mouni-product]')){schedule();setTimeout(schedule,120);}},true);
  window.addEventListener('click',event=>{const button=event.target.closest('[data-mouni-stock-disabled=true]');if(button){event.preventDefault();event.stopImmediatePropagation();}},true);
  window.addEventListener('submit',event=>{const root=event.target.closest('[data-mouni-product]');if(!root||!event.target.matches('form[action*="/cart/add"]'))return;const variant=variantFor(root);if(!variant)return;const left=capacity(variant);const quantity=Number(root.querySelector('quantity-input input[name=quantity]')?.value||1);if(quantity>left){event.preventDefault();event.stopImmediatePropagation();sync();}},true);
  const init=()=>{
    const snapshot=document.querySelector('[data-mouni-cart-snapshot]');
    try{cart=snapshot?JSON.parse(snapshot.textContent):null;}catch{}
    if(!cart)fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}}).then(r=>r.json()).then(next=>{cart=next;schedule();}).catch(()=>{});
    roots().forEach(root=>new MutationObserver(schedule).observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['value']}));
    schedule();
  };
  window.MouniStockGuard={sync:schedule};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();

